import React from "react";
import PropTypes from 'prop-types';

var ShareWeChat = function ShareWeChat(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 18 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 17 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58481 7.05682C6.45063 7.97727 5.81266 9.23864 5.81266 10.5682C5.81266 10.875 5.8481 11.1477 5.88354 11.4204L5.88354 11.4205C5.06835 11.3182 4.32405 11.0795 3.61519 10.7727L0.850633 12L1.16962 8.93182C0.425316 8.04545 0 6.95455 0 5.76136C0 2.59091 3.08354 0 6.98228 0C10.881 0 14 2.59091 14 5.76136V6.03409C13.2911 5.79545 12.5114 5.65909 11.7316 5.65909C10.1722 5.65909 8.68354 6.13636 7.58481 7.05682ZM10 4.01754C10 3.45614 9.55172 3 9 3C8.44828 3 8 3.42105 8 3.98246C8 4.54386 8.44828 5 9 5C9.55172 5 10 4.57895 10 4.01754ZM3 4C3 4.55172 3.44828 5 4 5C4.55172 5 5 4.55172 5 4C5 3.44828 4.55172 3 4 3C3.44828 3 3 3.44828 3 4ZM14.7993 7.45283C16.6756 8.20755 18 9.90566 18 11.8302C18 12.8491 17.6321 13.7547 17.0067 14.5094L17.2274 17L15.0936 16.0566C14.3211 16.3962 13.4381 16.6226 12.4816 16.6226C9.83278 16.6226 7.62542 14.9623 7.11037 12.8113C7.03679 12.4717 7 12.1321 7 11.7925C7 9.15094 9.46488 7 12.5184 7C13.3278 7 14.1003 7.18868 14.7993 7.45283ZM10 11C9.45455 11 9 10.5455 9 10C9 9.45455 9.45455 9 10 9C10.5455 9 11 9.45455 11 10C11 10.5455 10.5455 11 10 11ZM13 10C13 10.5455 13.4545 11 14 11C14.5455 11 15 10.5455 15 10C15 9.45455 14.5455 9 14 9C13.4545 9 13 9.45455 13 10Z",
    fill: fill
  }));
};

ShareWeChat.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareWeChat;